import React from 'react'

import { Popconfirm, Button, Tooltip, Icon } from 'antd'

import MovePopover            from "../MovePopover/index"

import './styles.scss'

export default ({
                    files,
                    files_loading,
                    previous_path,
                    on_navigate_back,
                    on_download,
                    on_delete,
                    on_share,
                    on_open_encode,
                    on_open_hybrik,
                    on_move
}) => {
  let move_target = null
  return (
    <div className='navigation-controls columnWrap'>
      <Button icon="left-circle-o" size={'small'} onClick={()=> on_navigate_back()} disabled={files_loading || !previous_path}>
        Back
      </Button>

      <div/>
      {
        (files.filter(i => i.checked).length > 0 && (on_download || on_delete || on_share || on_open_encode || on_open_hybrik || on_move)) ? (
          <div className={'options ' + (files.filter((i) => i.checked).length > 1) ? 'expand' : ''}>
            <span>Bulk  Actions</span>

            {
              on_move && <MovePopover ref={n=>move_target=n} target={
                <Tooltip title="Copy bucket to">
                  <Button ghost icon="circle" size={'small'} onClick={e=> on_move(move_target, files.filter((i) => i.checked))}>
                    <Icon type="copy"/>
                  </Button>
                </Tooltip>
              }/>
            }

            {/*{
              on_open_hybrik && <Tooltip title="Encode using Hybrik">
                <Button ghost icon="fork" size={'small'} onClick={()=> on_open_hybrik(files[0], 'Hybrik')}/>
              </Tooltip>
            }*/}

            {
              on_share && <Tooltip title="Share selected files">
                <Button ghost icon="share-alt" size={'small'} onClick={()=> on_share()}/>
              </Tooltip>
            }

            {
              on_delete &&
              <Popconfirm title={'Are you sure to delete ' + files.filter((i) => i.checked).length + ' selected files (All versions of the file(s) will be deleted)? '} placement="top" okText="Yes" cancelText="No" onConfirm={()=> on_delete()}>
                <Tooltip title="Delete selected files">
                  <Button ghost icon="delete" size={'small'}/>
                </Tooltip>
              </Popconfirm>
            }
            {
              on_download &&
              <Tooltip title="Download selected files">
                <Button ghost icon="download" size={'small'}  onClick={()=> on_download()}/>
              </Tooltip>
            }

          </div>
        ) : null
      }
    </div>
  )
}
